import styles from '@/components/book/FilterField.module.css';

interface FilterFieldProps {
  /** Read by assistive tech; the field itself shows only the italic placeholder. */
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

/** The underlined serif filter on the index and Contents. */
export function FilterField({ label, value, onChange, placeholder = 'Filter', className }: FilterFieldProps) {
  return (
    <label className={[styles.filter, className ?? ''].filter(Boolean).join(' ')}>
      <span className="sr-only">{label}</span>
      <input type="search" value={value} placeholder={placeholder} autoComplete="off" spellCheck={false} onChange={(e) => onChange(e.target.value)} />
    </label>
  );
}
